import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import { ChangePasswordPage } from "../../../auth/pages/changePassword/changePasswordPage";
import type { Navigation } from "../../../models/navigation";
import { Header } from "../../../shared/components/header";
import { useInIframe } from "../../../shared/hooks";
import { useStyles } from "./participantSettingsPage.styles";

type Props = {
  navigation: Navigation[];
};

export const ParticipantSettingsPage = ({ navigation }: Props) => {
  const classes = useStyles();
  const isInIframe = useInIframe();

  return (
    <Header navigation={navigation}>
      {!isInIframe ? (
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Typography
            component="h1"
            variant="h5"
            align="left"
            className={classes.title}
          >
            Settings
          </Typography>
        </Grid>
      ) : null}
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Paper className={classes.paper} elevation={0}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Typography variant="h4" className={classes.titleSeparator}>
              Change Password
            </Typography>
            <hr className={classes.lineHr} />
          </Grid>
          <ChangePasswordPage />
        </Paper>
      </Grid>
    </Header>
  );
};

ParticipantSettingsPage.propTypes = {
  navigation: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ),
};

ParticipantSettingsPage.defaultProps = {
  navigation: [],
};
